import './index.less';
import React from 'react';
import PropTypes from 'prop-types';
// Components
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';

const Spinner = ({ relative, size = 'large' }) => (
	<div className={`Spinner ${relative ? 'Spinner--relative' : 'Spinner--absolute'}`}>
		<ReactCKImage name="loading-wheel-purple" extraClasses={['buttonLoadingWheel', size]} />
	</div>
);

Spinner.propTypes = {
	relative: PropTypes.bool
};

export default Spinner;
